import styled, { css } from "styled-components"

export const PaddingSmall = css`
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: 780px;
`
export const PaddingMedium = css`
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: 1100px;
`
